(function(angular){
	'use strict';

	angular
		.module('settingsModule')
		.controller('ManageCarbonCopies', [
			'$document',
			'$scope',
			ManageCarbonCopiesFunction
		]);

	function ManageCarbonCopiesFunction(
		$document,
		$scope
	){
		var manageCarbonCopies = this;
		
		manageCarbonCopies.openConfirmationModal = function(id) {
			manageCarbonCopies.deleteUrl = id + '/delete';
			$scope.$broadcast('confirmationModal:open');
		};
		
		manageCarbonCopies.deleteCarbonCopy = function() {
			$document[0].getElementById('manageCarbonForm').submit();
		};
	}
})(window.angular);